import * as THREE from 'three'
import { useState, useEffect } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

interface AppleSparklesProps {
  position: THREE.Vector3
}

const APPLE_SPARKLES_COLOR = '#da2525'

const AppleSparkles = (props: AppleSparklesProps) => {
  const [animationPlaying, setAnimationPlaying] = useState(false)
  const stars_model = useGLTF('/models/portfolio_forest/stars_animation.glb')

  const [sceneClone, setSceneClone] = useState<THREE.Object3D<THREE.Object3DEventMap>>()
  const [mixer, setMixer] = useState<THREE.AnimationMixer>()

  useEffect(() => {
    const cloned_scene = stars_model.scene.clone()
    cloned_scene.animations = stars_model.animations
    setSceneClone(cloned_scene)

    cloned_scene.children.forEach((child) => {
      const child_mesh = child as THREE.Mesh
      child_mesh.material = new THREE.MeshBasicMaterial({ color: APPLE_SPARKLES_COLOR })
    })

    const mixer = new THREE.AnimationMixer(cloned_scene)
    setMixer(mixer)

    const animation_clip = cloned_scene.animations[0]
    mixer.clipAction(animation_clip).play()

    setAnimationPlaying(true)

    const timeout = setTimeout(() => {
      setAnimationPlaying(false)
    }, 970)

    return () => clearTimeout(timeout)
  }, [stars_model])

  useFrame((_state, delta) => {
    if (!animationPlaying || !sceneClone) return
    if (mixer) mixer.update(delta)
  })

  if (!animationPlaying || !sceneClone) return null

  return (
    <group position={props.position} scale={0.8}>
      <primitive object={sceneClone} />
    </group>
  )
}

export default AppleSparkles

useGLTF.preload('/models/portfolio_forest/stars_animation.glb')
